import React from "react"
import { BgImage } from "gbimage-bridge"
// import PropTypes from "prop-types"
// import Image from "gatsby-image"
import { Link } from "gatsby"
const NewsItem = ({ date, category, slug, title, image }) => {
  
  return (
    <BgImage image={image.childImageSharp.gatsbyImageData} Tag="li" className="gs-news-list-item">
      <Link to={`/blogs/${slug}`} className="gs-news-list-item__link">
        <div>
          <span className="gs-news-list__tag ffosw">{category}</span>
          <span className="gs-news-list__date fw300">{date}</span>
          <h5 className="gs-news-list__title">{title}</h5>
        </div>
      </Link>
    </BgImage>
  );
}

NewsItem.propTypes = {}

export default NewsItem
